module.exports = __webpack_public_path__ + "static/img/12.39f5ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/12.png
// module id = EqJr
// module chunks = 0